import { useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../actions/auth_actions";

function AutoLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const events = [
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress"
    ];

    let logoutTimer;

    const logoutCallback = () => {
      dispatch(logout(null, navigate, "inactivity"));
    };

    const resetTimeout = () => {
      if (logoutTimer) clearTimeout(logoutTimer);
      logoutTimer = setTimeout(logoutCallback, 60 * 60 * 1000); // 60 minutes
    };

    events.forEach(event => {
      window.addEventListener(event, resetTimeout);
    });

    resetTimeout(); // Initialize the timer

    return () => {
      events.forEach(event => {
        window.removeEventListener(event, resetTimeout);
      });
      clearTimeout(logoutTimer);
    };
  }, [dispatch, navigate]);

  return null; // This component does not render anything
}

export default AutoLogout;